<template>
  <div>
    <el-form :model="addCustomer" ref="addCustomerRef" label-width="68px">
      <el-form-item label="姓名" class="addAdminForm">
        <el-input v-model="addCustomer.name" placeholder="请输入用户姓名"></el-input>
      </el-form-item>
      <el-form-item label="年龄" class="addAdminForm">
        <el-input v-model="addCustomer.age" placeholder="请输入用户年龄"></el-input>
      </el-form-item>
      <el-form-item label="账号" class="addAdminForm">
        <el-input v-model="addCustomer.customerloginname" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" class="addAdminForm">
        <el-input v-model="addCustomer.customerpassword" type="password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <!-- 视光信息 start -->
      <div class="title">视光信息</div>
      <div class="optometry">
        <el-form-item label="屈光状态" class="select2">
          <el-select v-model="addCustomer.diopterstate" placeholder="请选择" style="width: 100%">
            <el-option label="请选择" value="0"></el-option>
            <el-option label="正视" value="6"></el-option>
            <el-option label="远视" value="2"></el-option>
            <el-option label="近视" value="1"></el-option>
            <el-option label="散光" value="7"></el-option>
            <el-option label="老花" value="3"></el-option>
            <el-option label="屈光参差" value="8"></el-option>
            <el-option label="远视性弱视" value="9"></el-option>
            <el-option label="散光性弱视" value="10"></el-option>
            <el-option label="近视性弱视" value="11"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 视光信息 end -->

      <!-- 屈光度 -->
      <el-table :data="diopterData" border stripe class="mt20">
        <el-table-column label="屈光度" align="center">
          <el-table-column label="OD(右眼)" align="center">
            <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.righteyedegree" class="input_num"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.rightcolumnmirror" class="input_num"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.rightaxial" class="input_num"></el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="OS(左眼)" align="center">
            <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.lefteyedegree" class="input_num"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.leftcolumnmirror" class="input_num"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.leftaxial" class="input_num"></el-input>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>

      <!-- ADD和调节幅度 -->
      <el-table :data="addData" border stripe class="mt20">
        <el-table-column label="ADD和调节幅度" align="center">
          <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
            <template slot-scope="scope">
              <el-select v-model="addCustomer.addtype" placeholder="请选择" style="width: 100%">
                <el-option label="0.00D" value="0"></el-option>
                <el-option label="0.50D" value="1"></el-option>
                <el-option label="0.75D" value="2"></el-option>
                <el-option label="1.00D" value="3"></el-option>
                <el-option label="1.25D" value="4"></el-option>
                <el-option label="1.50D" value="5"></el-option>
                <el-option label="1.75D" value="6"></el-option>
                <el-option label="2.00D" value="7"></el-option>
                <el-option label="2.25D" value="8"></el-option>
                <el-option label="2.50D" value="9"></el-option>
                <el-option label="2.75D" value="10"></el-option>
                <el-option label="3.00D" value="11"></el-option>
                <el-option label="3.25D" value="12"></el-option>
                <el-option label="3.50D" value="13"></el-option>
                <el-option label="3.75D" value="14"></el-option>
                <el-option label="4.00D" value="15"></el-option>
                <el-option label="4.25D" value="16"></el-option>
                <el-option label="4.50D" value="17"></el-option>
                <el-option label="4.75D" value="18"></el-option>
                <el-option label="5.00D" value="19"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="adjust" label="调节幅度(范围:0.00D~+22.00D)">
            <template slot-scope="scope">
              <el-input v-model="addCustomer.amp"></el-input>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <!-- 裸眼和矫正视力 -->
      <el-table :data="nakedEye" border stripe class="mt20">
        <el-table-column label="5m裸眼视力(5分记录法)" align="center">
          <el-table-column prop="odRight" label="OD(右眼)">
            <template slot-scope="scope">
              <el-select v-model="addCustomer.nakedrighteyedegree" placeholder="请选择">
                <el-option
                  v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="osLeft" label="OS(左眼)">
            <template slot-scope="scope">
              <el-select v-model="addCustomer.nakedlefteyedegree" placeholder="请选择">
                <el-option
                  v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ouDouble" label="OU(双眼)">
            <template slot-scope="scope">
              <el-select v-model="addCustomer.nakedbinoculusdegree" placeholder="请选择">
                <el-option
                  v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="最佳矫正视力(5分记录法)" align="center">
          <el-table-column prop="odRight1" label="OD(右眼)">
            <template slot-scope="scope">
              <el-select v-model="addCustomer.correctrighteyedegree" placeholder="请选择">
                <el-option
                  v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="osLeft1" label="OS(左眼)">
            <template slot-scope="scope">
              <el-select v-model="addCustomer.correctlefteyedegree" placeholder="请选择">
                <el-option
                  v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ouDouble1" label="OU(双眼)">
            <template slot-scope="scope">
              <el-select v-model="addCustomer.correctbinoculusdegree" placeholder="请选择">
                <el-option
                  v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <!-- 瞳距 -->
      <el-table :data="tongJuData" border stripe class="mt20">
        <el-table-column  prop="tongju" label="瞳距(单位:mm)">
          <template slot-scope="scope">
            <el-input v-model="addCustomer.interpupillary"></el-input>
          </template>
        </el-table-column>
      </el-table>

      <el-form-item class="mt20">
        <el-button type="primary" @click="clickAdd">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      fullscreenloading: false,
      // 添加客户
      addCustomer: {
        name: '',
        age: '',
        customerloginname: '',
        customerpassword: '',
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        addtype: '0',
        amp: '0.00',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: ''
      },
      //
      diopterData: [
        {
          rightEye1: '右眼',
          rightEye2: '右眼',
          rightEye3: '右眼',
          leftEye1: '右眼',
          leftEye2: '右眼',
          leftEye3: '右眼'
        }
      ],
      // ADD和调节幅度
      addData: [
        {
          add: 'add',
          adjust: '调节幅度'
        }
      ],
      // 裸眼和矫正视力
      nakedEye: [
        { odRight: '请选择', osLeft: '请选择', ouDouble: '请选择', odRight1: '请选择', osLeft1: '请选择', ouDouble1: '请选择' }
      ],
      tongJuData: [
        { tongju: '请输入', leftEye: '请选择', rightEye: '请选择' }
      ],
      eyedegreelist: [
        { value: '0', label: '请选择' },
        { value: '3.5', label: '3.5' },
        { value: '3.6', label: '3.6' },
        { value: '3.7', label: '3.7' },
        { value: '3.8', label: '3.8' },
        { value: '3.9', label: '3.9' },
        { value: '4.0', label: '4.0' },
        { value: '4.1', label: '4.1' },
        { value: '4.2', label: '4.2' },
        { value: '4.3', label: '4.3' },
        { value: '4.4', label: '4.4' },
        { value: '4.5', label: '4.5' },
        { value: '4.6', label: '4.6' },
        { value: '4.7', label: '4.7' },
        { value: '4.8', label: '4.8' },
        { value: '4.9', label: '4.9' },
        { value: '5.0', label: '5.0' },
        { value: '5.1', label: '5.1' },
        { value: '5.2', label: '5.2' },
        { value: '5.3', label: '5.3' }
      ]
    }
  },
  mounted () {

  },
  methods: {
    initData () {
      this.addCustomer.name = ''
      this.addCustomer.age = ''
      this.addCustomer.customerloginname = ''
      this.addCustomer.customerpassword = ''
      this.addCustomer.diopterstate = '0'
      this.addCustomer.righteyedegree = '0.00'
      this.addCustomer.rightcolumnmirror = '0.00'
      this.addCustomer.rightaxial = '0'
      this.addCustomer.lefteyedegree = '0.00'
      this.addCustomer.leftcolumnmirror = '0.00'
      this.addCustomer.leftaxial = '0'
      this.addCustomer.addtype = '0'
      this.addCustomer.amp = '0.00'
      this.addCustomer.nakedrighteyedegree = '0'
      this.addCustomer.nakedlefteyedegree = '0'
      this.addCustomer.nakedbinoculusdegree = '0'
      this.addCustomer.correctrighteyedegree = '0'
      this.addCustomer.correctlefteyedegree = '0'
      this.addCustomer.correctbinoculusdegree = '0'
      this.addCustomer.interpupillary = ''
    },
    clickAdd () {
      this.apiRslEvAddUser()
    },
    apiRslEvAddUser: function () {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.addCustomer.name,
        age: that.addCustomer.age,
        loginname: that.addCustomer.customerloginname,
        password: that.addCustomer.customerpassword,
        diopterstate: that.addCustomer.diopterstate,
        righteyedegree: that.addCustomer.righteyedegree,
        rightcolumnmirror: that.addCustomer.rightcolumnmirror,
        rightaxial: that.addCustomer.rightaxial,
        lefteyedegree: that.addCustomer.lefteyedegree,
        leftcolumnmirror: that.addCustomer.leftcolumnmirror,
        leftaxial: that.addCustomer.leftaxial,
        addtype: that.addCustomer.addtype,
        amp: that.addCustomer.amp,
        nakedrighteyedegree: that.addCustomer.nakedrighteyedegree,
        nakedlefteyedegree: that.addCustomer.nakedlefteyedegree,
        nakedbinoculusdegree: that.addCustomer.nakedbinoculusdegree,
        correctrighteyedegree: that.addCustomer.correctrighteyedegree,
        correctlefteyedegree: that.addCustomer.correctlefteyedegree,
        correctbinoculusdegree: that.addCustomer.correctbinoculusdegree,
        interpupillary: that.addCustomer.interpupillary
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvAddUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
